import { reads } from '@ember/object/computed';
import { service } from '@ember/service';

import ActiveModelAdapter from 'active-model-adapter';

import { authBaseURL, authNamespace } from 'register-partners-js/constants/hosts';

export default class BaseAuthAdapter extends ActiveModelAdapter {
  host = authBaseURL;
  namespace = authNamespace;

  @service networkManager;

  @reads('networkManager.requestHeaders') headers;

  ajaxOptions() {
    let options = super.ajaxOptions(...arguments);
    options.credentials = 'include';
    return options;
  }
}
